import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MarketData } from 'app/models/MarketData';
import { DataService } from 'app/shared/data.service';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-actif-search',
    standalone: true,
    imports: [CommonModule, MatIcon, SharedModule, RouterModule],
    templateUrl: './actif-search.component.html',
})
export class ActifSearchComponent implements OnInit {
    rapidAccessResult: MarketData[] = [];
    rapidAccessText: string = '';
    actifs: MarketData[] = [];

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.chargerActifs();
    }

    chargerActifs() {
        this.dataService.recupererTout().subscribe({
            next: (data: MarketData[]) => {
                this.actifs = data;
            },
        });
    }

    onSearchChange() {
        if (this.rapidAccessText)
            this.rapidAccessResult = this.actifs
                .filter((actif) =>
                    actif?.referentiel?.stockName
                        .toLowerCase()
                        .includes(this.rapidAccessText.toLowerCase())
                )
                .slice(0, 10);
        else this.rapidAccessResult = [];
    }
}
